export default {
    localizations: [],
    localizationsLoading: false,
    filters: setInitialFilters(),
    setInitialFilters: setInitialFilters
}

function setInitialFilters() {
    return {
        search: null
    }
}